export const formatCurrency = (amount: number | string, currencyCode?: string, locale?: string): string => {
	const currencyAbreviation = currencyCode || 'USD';
	const formattedAmount = new Intl.NumberFormat(locale || 'en-US', {
		style: 'currency',
		currency: currencyAbreviation,
		currencyDisplay: 'narrowSymbol'
	}).format(Number(amount));

	return `${currencyAbreviation.toUpperCase()} ${formattedAmount}`;
};
